import React, { useContext, useEffect, useState } from "react";

import { Tabs, Tab, Box } from "@material-ui/core";
import ManageStartupAccounts from "views/Dashboard/ManageStartupAccounts/ManageStartupAccounts";
import StartupUnEnrollments from "views/Dashboard/StartupUnEnrollments/StartupUnEnrollments";
import StartupAudit from 'views/Dashboard/StartupAudit/StartupAudit';
import ThriveStartUpEnrollments from "views/Dashboard/ThriveStartUpEnrollments/ThriveStartUpEnrollments";





import Context from 'context/context';


 





export default function StartupTab() {
  const [value, setValue] = useState(0);
  const { state, dispatch } = useContext(Context);
  const [allowedTabs, setAllowedTabs] = useState([]);
let disable=true
  const handleChange = (event, newValue) => {
    if(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'){
    setValue(newValue);
    }else {
      
      newValue=newValue==1?2:newValue
  

    setValue(newValue);

    }
  };

  // Optional: Store components in an array to easily switch
  let components
const allComponents = [
  {
    path: "/dashboard/manage-startup-accounts-tab",
    label: "Manage Startup Accounts",
    element: <ManageStartupAccounts />,
  },
  

  {
    path: "/dashboard/thrive-startup-enrollments",
    label: "Enrollments",
    element: <ThriveStartUpEnrollments />,
  },  
  {
    path: "/dashboard/startup-unenrollments",
    label: "Unenrollments",
    element: <StartupUnEnrollments />,
  }, 

  
  {
    path: "/dashboard/audit-startup",
    label: "Audit Startup",
    element: <StartupAudit />,
  },

 

];
useEffect(() => {
  if (state && state.userInfo && Object.keys(state.userInfo).length > 0) {
    if (
      state &&
      state.userInfo.allowedRoutes &&
      Object.keys(state.userInfo.allowedRoutes).length > 0
    ) {
      const allowed = allComponents.filter((comp) =>
      state.userInfo.allowedRoutes.some((api) => api.path
      === comp.path)
    );

    setAllowedTabs(allowed);

    }
  }
}, [state.userInfo]);

console.log(allowedTabs,"allowedTabs")
 


  return (
    <Box>
  
      <Tabs value={value} onChange={handleChange} aria-label="Points Management Tabs"
      TabIndicatorProps={{
    style: { backgroundColor: '#007bff' }, // e.g., '#1976d2' for blue
  }}>
         {allowedTabs.map((tab, index) => (
          <Tab
            key={tab.path}
            label={tab.label}
            sx={{ textTransform: "none" }}
          />
        ))}

        

      </Tabs>
   

      <Box sx={{ p: 2 }}>
      {allowedTabs.length > 0 && allowedTabs[value]?.element}
    </Box>
    </Box>
  );
}
